<script>
    // Stores 
    import { textSite, mailLocacao, mailVendas } from '../store.js';    
    import { afterUpdate } from 'svelte';

    // Componentes
    import { Router, Link, link , Route } from "svelte-routing";
    import Forms from "../components/Forms.svelte";  
    import PageHeader from './../components/PageHeader.svelte';

    // Code
    let titlePage = 'Indicação Premiada';

    let fields = [
        {
            title:  'Nome *',
            name:   'nome',
            required:   'required'
        },
        {
            title:  'Telefone *',
            name:   'telefone',
            required: 'required',
            classe:   'mask-telefone'
        },
        {
            title:  'Email *',
            name:   'email',
            type:   'email',
            required: 'required',
        },
        {
            title:  'Indicação *',
            name:   'indicacao',
            required: 'required',
            type:   'select',
            selectValues : [
                {title : 'Imóvel para Locação', value: 'Imóvel para Locação'},
                {title : 'Imóvel para Venda', value: 'Imóvel para Venda'},
                {title : 'Imóvel para Locação ou Venda', value: 'Imóvel para Locação ou Venda'}
            ],
        },   
        {
            title:  'Tipo do Imóvel *',
            name:   'imovel-tipo',
            required: 'required',
            type:   'select',
            selectValues : [
                {title : 'Tipo do Imóvel', value: ''},
                {title : 'Apartamento', value: 'Apartamento'},
                {title : 'Cobertura', value: 'Cobertura'},
                {title : 'Casa Residencial', value: 'Casa Residencial'},
                {title : 'Loja', value: 'Loja'},
                {title : 'Sala/Conjunto', value: 'Sala/Conjunto'},
                {title : 'Pavilhão/depósito', value: 'Pavilhão/depósito'},
                {title : 'Terreno', value: 'Terreno'},
                {title : 'Outros', value: 'Outros'}
            ],
        },   
        {
            title:  'Endereço do Imóvel *',
            name:   'imovel-endereco',
            required: 'required',
        },        {
            title:  'Bairro *',
            name:   'bairro',
            required: 'required',
        },        
        {
            title:  'Cidade *',
            name:   'cidade',
            required: 'required',
        },
        {
            title:     'Características',
            name:      'caracteristicas',
            type:      'textarea',
            rows: 4
        },
        {
            title:  'Preço R$ *',
            name:   'preco',
            required: 'required',
            classe: 'mask-number',
        },                
        {
            title:  'Nome do Proprietário*',
            name:   'nomeprop',
            required:   'required'
        },
        {
            title:  'Telefone do Proprietário *',
            name:   'telefoneprop',
            required: 'required',
            classe:   'mask-telefone'
        },
        {
            title:  'Email do Proprietário *',
            name:   'emailprop',
            type:   'email',
            required: 'required',
        },       
    ];

    const message = `
Nome: {nome}
Telefone: {telefone}
Email: {email}
Indicação: {indicacao}
Tipo do Imóvel: {imovel-tipo}
Endereço do Imóvel: {imovel-endereco}
Bairro: {bairro}
Cidade: {cidade}
Características: {caracteristicas}
Preço R$: {preco}
Nome do Proprietário: {nomeprop}
Telefone do Proprietário: {telefoneprop}
Email do Proprietário: {emailprop}

{info}
    `;

    let loading = false;

    function send() {
        loading = true;
    }
   
    let destiny = $mailLocacao;

    afterUpdate(() => {
        try{
            /* Alteração destino conforme indicacao */
            let queryEscolha = document.querySelector('#indicacao');
    
            queryEscolha.addEventListener("change", function(){
                let escolha = queryEscolha.value;
                destiny = escolha == "Imóvel para Venda" ? $mailVendas : $mailLocacao;    
            });
        }catch(ex) { 

        } 
    });

</script>

<section class="conteudo-internas">
    <PageHeader title={titlePage}></PageHeader>
    <div class="container">
        <p class="text-center">
            Participe da <b>Indicação Premiada</b> da {$textSite}. Conheça as <b><a href="/assets/files/IndicacaodeImoveisYaraImobiliaria_20210330.pdf" target="_blank">condições gerais <i class="far fa-external-link-square-alt"></i></a></b>.
        </p>
        <p class="text-center">
            Entre em contato preenchendo o formulário abaixo. Retornaremos para confirmação dos dados e validação da sua indicação.
        </p>
        <div class="offset-md-3 col-md-6 pl-0 pr-0">       
            <hr class="line-separator">
            <Forms fields={fields} destiny={destiny} subjectTitle="Indique | {$textSite}" {message} htmlbody={false} />
        </div>
    </div>
</section>